import React, {useState} from "react";
import { CareerItemModel } from "../../../domain/entities/CareerItemModel";
import { Clock, GraduationCap, MapPin } from 'lucide-react';
import Modal from "../modal/Modal";

interface CareerItemProps {
    career: CareerItemModel
}

const CareerItem: React.FC<CareerItemProps> = ({career}) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);

    return (
        // Container with rounded corners and subtle shadow
        <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-600">
            {/* Header section with title and detail button */}
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold text-gray-900">{career.title}</h2>
                <button className="px-4 py-2 md:px-6 md:py-4 bg-pink-800 text-white font-poppins font-semibold rounded-3xl hover:bg-pink-900 transition-colors"
                    onClick={openModal}>
                    Detail
                </button>
            </div>

            {/* Job details with icons */}
            <div className="flex flex-wrap gap-10">
                {/* Full Time */}
                <div className="flex items-center gap-2 text-gray-600">
                    <Clock className="w-5 h-5" />
                    <span>{career.type.name}</span>
                </div>

                {/* Education Requirement */}
                <div className="flex items-center gap-2 text-gray-600">
                    <GraduationCap className="w-5 h-5" />
                    <span>{career.education_level.name}</span>
                </div>

                {/* Location */}
                <div className="flex items-center gap-2 text-gray-600">
                    <MapPin className="w-5 h-5" />
                    <span>{career.location}</span>
                </div>
            </div>

            <Modal isOpen={isModalOpen} onClose={closeModal}>
                <div className="p-4 md:p-8">
                    <h2 className="text-3xl font-semibold font-poppins text-black">{career.title}</h2>
                    {/* Image container with specific aspect ratio */}
                    <div className="w-full h-[200px] overflow-hidden rounded-2xl">
                        <img 
                            src={career.image_url} 
                            className="w-full h-full object-cover"
                            alt={career.title}
                        />
                    </div>
                    <p className="text-lg text-black font-semibold font-poppins mt-4 md:mt-8">Persyaratan</p>
                    <ul className="list-disc pl-5 mt-2 md:mt-4">
                        {career.job_requirements.map((requirement, index) => (
                            <li key={index} className="text-sm text-gray-700 font-light font-poppins mb-2">
                                {requirement}
                            </li>
                        ))}
                    </ul>
                    <p className="text-lg text-black font-semibold font-poppins mt-4 md:mt-8">Deskripsi Pekerjaan</p>
                    <ul className="list-disc pl-5 mt-2 md:mt-4">
                        {career.job_description.map((description, index) => (
                            <li key={index} className="text-sm text-gray-700 font-light font-poppins mb-2">
                                {description}
                            </li>
                        ))}
                    </ul>
                </div>
            </Modal>
        </div>
    );
}

export default CareerItem;